import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

const FormSubmit = ({ clickSubmitHandle, saveFormDataHandle }) => {
    // const surveyEndHandle = () => {
    //     alert('报名已结束');
    // };

    return (
        <div className={styles.formSubmit}>
            <div className={styles.formSubmitSave} onClick={saveFormDataHandle} />
            <div
                className={styles.formSubmitButton}
                onClick={() => {
                    clickSubmitHandle(true);
                }} />
        </div>
    );
};

FormSubmit.propTypes = {
    clickSubmitHandle: PropTypes.func,
    saveFormDataHandle: PropTypes.func,
};

export default errorBoundary(FormSubmit);
